// extracted by mini-css-extract-plugin
export default {"host":"FilterAreaButton_host__wNOKn","host_selected":"FilterAreaButton_host_selected__EeAva"};